export const detectors = [
    {
        name: 'RFMD-100',
        type: 'detector',
        tech: 'wireless',
        refImg: 'rfmd-100.png',
        price: 68.14,
    },
    {
        name: 'RFMD-200',
        type: 'detector',
        tech: 'wireless',
        refImg: 'rfmd-200.png',
        price: 76.10,
    },
    {
        name: 'RFPD-100',
        type: 'detector',
        tech: 'wireless',
        refImg: 'rfpd-100.png',
    },
    {
        name: 'RFWD-100',
        type: 'detector',
        tech: 'wireless',
        refImg: 'rfwd-100.png',
        price: 52.31
    }
];